import React from 'react';
import { Shield, Heart } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  const scrollToPrice = () => {
    document.getElementById('price-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full min-h-[90vh] flex flex-col items-center justify-start overflow-hidden bg-creme pt-12 pb-24 px-6" data-id="element-54">
      <div className="w-full max-w-5xl mx-auto flex flex-col items-center" data-id="element-55">
        {/* Image Content */}
        <FadeIn delay={0.1} fullWidth data-id="element-56">
          <div className="w-full max-w-4xl mx-auto mb-12" data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/jfJhvJujV2gXhun7HAxKQU/promts_landing_bullying.png" alt="Madre consolando a su hijo" className="w-full h-auto object-cover object-center rounded-3xl shadow-soft" data-id="element-58" />
          </div>
        </FadeIn>

        {/* Text Content */}
        <div className="w-full max-w-3xl flex flex-col items-center text-center" data-id="element-59">
          <FadeIn delay={0.2} data-id="element-60">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-beige text-soft-brown text-sm font-medium mb-8" data-id="element-61">
              <Shield className="w-4 h-4 text-warm-accent" data-id="element-62" />
              <span className="tracking-wide" data-id="element-63">
                Protocolo Anti-Acoso Escolar
              </span>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-64">
            <h1 className="font-cormorant font-light text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-dark-coffee mb-8" data-id="element-65">
              Mañana tu hijo puede volver al colegio{' '}
              <span className="italic font-bold text-warm-accent" data-id="element-66">
                sin miedo.
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-67">
            <p className="text-lg md:text-xl text-soft-brown mb-12 leading-relaxed max-w-2xl font-sans font-light" data-id="element-68">
              Frená el acoso escolar de tu hijo en menos de 24 horas. Sin
              esperar al colegio, sin violencia y sin mentiras. El protocolo
              práctico que mañana le devuelve la paz.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-69">
            <button onClick={scrollToPrice} className="w-full sm:w-auto bg-warm-accent hover:bg-[#8A4525] text-white font-bold py-5 px-10 rounded-full transition-all duration-300 animate-pulse-glow flex items-center justify-center gap-3 text-lg tracking-wide shadow-xl" data-id="element-70">
              SÍ, QUIERO PROTEGER A MI HIJO
            </button>
          </FadeIn>
        </div>
      </div>
    </section>;
}